// extracted by mini-css-extract-plugin
export default {"pageTitle":"pageTitle__SWAozryq","pageSubtitle":"pageSubtitle__x3KIfQpE","row":"row__OpTOAS11","header":"header__sFw1eFq2","icon":"icon__fK75g5bg"};